<!--
<footer class="text-center text-lg-start bg-light text-muted">


  <img src="images/cintillo.png" alt="" class="w-100 d-inline-block align-text-top">
</footer>

-->

<footer class="d-flex flex-wrap justify-content-between align-items-center">
  <img src="images/cintillo.jpg" alt="" class="w-100 d-inline-block align-text-top" style="height: 70px">
</footer>
